import { CustomFormTemplate } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  page: number;
  limit: number;
}

interface ResponseDataType {
  response: CustomFormTemplate[];
}

export const getCustomFormTemplatesListRequest = ({ token, page, limit }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template?page=${ page }&limit=${ limit }`, {
    token,
  });
};